import { useState } from 'react'

import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'

import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { useProjectdossierGlobalsLists } from '../../valuelists/hooks/useProjectdossierGlobalsLists'
import { useProjectdossierOrganisationLists } from '../../valuelists/hooks/useProjectdossierOrganisationLists'
import { useValuelists } from '../../valuelists/hooks/useValuelists'
import { ProjectdossiersFilters } from '../components/ProjectdossiersFilters'
import { ProjectdossiersTableRow } from '../components/ProjectdossiersTableRow'
import { CreateProjectdossierDialog } from '../components/dialogs/CreateProjectdossierDialog'
import { useProjectdossiersSearch } from '../hooks/useProjectdossiersSearch'

const headerCells = [
  {
    id: 'projectdossierId',
    numeric: true,
    label: 'Projectdossier id',
    sort: false,
  },
  {
    id: 'projectdossier',
    numeric: false,
    label: 'Projectdossier',
    sort: false,
  },
  { id: 'externeReferentie', numeric: false, label: 'Referentie', sort: false },
  { id: 'gebiedsCodeLabel', numeric: false, label: 'Gebied', sort: false },
  { id: 'status', label: 'Status', sort: false },
  { id: 'indiener.naam', numeric: false, label: 'Indiener', sort: true },
  {
    id: 'indiener.organisatie',
    numeric: false,
    label: 'Organisatie',
    sort: true,
  },
  { id: 'aanlegger.date', label: 'Aanmaakdatum', sort: true, fixed: 75 },
  { id: 'details', label: 'Details', sort: false, fixed: 50 },
] as const

export const Projectdossiers = () => {
  const { data: valuelists } = useValuelists()
  const { data: globals } = useProjectdossierGlobalsLists()
  const { data: organisation } = useProjectdossierOrganisationLists()
  const {
    data: { items: projectdossiers, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangePage,
    onChangeSort,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useProjectdossiersSearch()

  const [open, setOpen] = useState<boolean>(false)

  return (
    <Page
      title={['Projectdossiers', 'Ketensamenwerking']}
      breadcrumbs={[
        { label: 'Ketensamenwerking', href: '/home', tooltip: 'CAPO home' },
        { label: 'Projectdossiers' },
      ]}
      fillScreen
    >
      <PageSection
        id="projectdossiers"
        heading="Overzicht van alle projectdossiers in uw gebied"
      />

      <Paper>
        <ProjectdossiersFilters
          onChange={onChangeFilters}
          filters={filters}
          initialFilters={initialFilters}
          onCreate={() => setOpen(true)}
          onReset={onReset}
          onRefresh={onRefresh}
          filterOptions={{
            gebieden: valuelists.gebieden,
            projectdossier: {
              status: globals.status,
              verantwoordelijken: organisation.verantwoordelijken,
            },
          }}
        />
        <StyledTable
          onChangePage={onChangePage}
          onChangeSort={onChangeSort}
          headerCells={headerCells}
          sort={sort}
          stats={{ count, skip, limit }}
          loading={isLoading}
          isError={isError}
          {...({} as any)}
        >
          {projectdossiers.map((projectdossier) => (
            <ProjectdossiersTableRow
              key={projectdossier._id}
              projectdossier={projectdossier}
            />
          ))}
        </StyledTable>
      </Paper>
      {open && (
        <CreateProjectdossierDialog
          onClose={() => setOpen(false)}
          gebieden={valuelists.gebieden}
        />
      )}
    </Page>
  )
}
